// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Türkiye */
const TR: PhoneNumberData = [90, 'TR', 10, '000 000 00 00'];

export default TR;
